module.exports = __webpack_public_path__ + "static/media/pla_clear_strew3.0813097b.png";